<template>
  <div>
    <div class="col-12">
      <q-card style="width: 100%">
        <q-card-section>
          <div v-html="data.noticeContents"></div>
        </q-card-section>
      </q-card>
    </div>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'user-pop',
  props: {
    popupParam: {
      type: Object,
      default: function() {
        return {
          type: 'single',
          plantCd: '',
        }
      },
    },
  },
  data() {
    return {
      detailUrl: '',
      data: {
        noticeContents: '',
      },
      editable: true,
      listUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  watch: {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.detailUrl = selectConfig.sys.notice.get.url;
      // code setting
      this.getList();
    },
    getList() {
      this.$http.url = this.$format(this.detailUrl, this.popupParam.sysNoticeId);
      this.$http.type = 'GET';
      this.$http.request((_result) => {
        this.data = _result.data;
      },
      () => {
      });
    },
  }
};
</script>
